module.exports = __webpack_public_path__ + "img/photo-08.123dff94.jpg";